const DomainUrl = `https://backend.scout-x.com/en/api`;
// const DomainUrl = `https://staging.scout-x.com/en/api`;
export default DomainUrl;
